import RegularProduct from 'components/ProductPage/Type/RegularProduct/RegularProduct';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showHighlightLayerWithPDP } from 'viewModel/selectors/testTarget/showHighlightLayerWithPDP';
import { isShowSMNEnabledSelector } from 'viewModel/selectors/testTarget/showSMNSelector';
import { featuresAIBeautyChatSelector } from 'ai/selectors/testTarget/featuresAIBeautyChatSelector';
import { showCollapseInfoSectionSelector } from 'viewModel/selectors/testTarget/showCollapseInfoSectionSelector';
import { showAddDropDownReviewSectionSelector } from 'viewModel/selectors/testTarget/showAddDropDownReviewSectionSelector';
import { showAtbCarouselsPDPSelector } from 'viewModel/selectors/testTarget/showAtbCarouselsPDPSelector';
import { showReorderPageSectionPdpSelector } from 'viewModel/selectors/testTarget/showReorderPageSectionPdpSelector';
import { showSocialProofPDPSelector } from 'viewModel/selectors/testTarget/showSocialProofPDPSelector';
import { showSmnCaPpageCarouselSelector } from 'viewModel/selectors/testTarget/showSmnCaPpageCarouselSelector';
import { showSmnCaPpageBannerSelector } from 'viewModel/selectors/testTarget/showSmnCaPpageBannerSelector';

const fields = createStructuredSelector({
    highlightLayerWithPDP: showHighlightLayerWithPDP,
    featuresAIBeautyChat: featuresAIBeautyChatSelector,
    showSMNEnabled: isShowSMNEnabledSelector,
    showCollapseInfoSection: showCollapseInfoSectionSelector,
    showAddDropDownReviewSection: showAddDropDownReviewSectionSelector,
    isCarouselsATBEnabled: showAtbCarouselsPDPSelector,
    reorderPageSectionPdp: showReorderPageSectionPdpSelector,
    showSocialProofPDP: showSocialProofPDPSelector,
    showSmnCaPpageCarousel: showSmnCaPpageCarouselSelector,
    showSmnCaPpageBanner: showSmnCaPpageBannerSelector
});

const withHighlightValueVisibilityProps = connect(fields);

export default withHighlightValueVisibilityProps(RegularProduct);
